<template>
  <div class="page-container content-430">
    <div class="title-block">配置分账信息</div>
    <Row type="flex" style="margin-bottom:16px">
      <div class="content-line">
        <span class="line-left">课程挂靠机构</span>
        <Button type="primary" shape="circle">{{ hangingOrgName }}</Button>
      </div>
      <div class="content-line">
        <span class="line-left">三方课程机构</span>
        <Button type="primary" shape="circle">{{ goodsProviderName }}</Button>
      </div>
    </Row>
    <div class="title-block">分账列表</div>
    <Row type="flex" justify="end" style="margin-bottom:16px">
      <Button type="primary" @click="handleAddDivideInfo">新建分账规则</Button>
    </Row>
    <div class="table-main">
      <Table border :columns="tableColumns" :data="tableData" :loading="tableLoading">
        <template slot="schoolRelDTOList" slot-scope="{ row }">
          <TablePoptip v-if="row.schoolRelDTOList&&row.schoolRelDTOList.length>0" :content="row.schoolStr" :show-poptips-content-length="30" :content-width="230"> </TablePoptip>
          <span v-else>不限</span>
        </template>

        <template slot="ruleType" slot-scope="{ row }">
          <span>{{ ruleTypeObj[row.ruleType] }}</span>
        </template>
        <template slot="isEnable" slot-scope="{ row }">
          <span v-if="row.isEnable===1" class="pass-status-430">开启</span>
          <span v-if="row.isEnable===0" class="stop-status-430">已关闭</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span class="click-btn-430" @click="handleEditDivideInfo(row)">编辑</span>
          <span class="click-btn-430" style="color: red" @click="handleDelDivideInfo(row)">删除</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page class="page-right" :total="pageInfo.total" show-sizer show-elevator show-total :current="pageInfo.pageNo" :page-size-opts="pageSizeOpts" @on-change="handlePageChange" @on-page-size-change="handlePageSize"></Page>
    </div>
    <Modal v-model="showDivideModal" width="80" :title="modalTitle">
      <Form
        ref="divideInfoForm"
        label-position="right"
        :label-width="150"
        class="info-form"
        :model="divideInfo"
        :rules="divideInfoRule"
      >
        <FormItem label="分账规则名称" prop="ruleName">
          <Input
            v-model="divideInfo.ruleName"
            class="form-select"
            placeholder="请输入分账规则名称"
            style="width:200px"
          ></Input>
        </FormItem>
        <FormItem label="分账业务类型" prop="ruleType">
          <CheckboxGroup v-model="divideInfo.ruleType">
            <Checkbox :label="1">素质课程</Checkbox>
            <Checkbox :label="4">材料费</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="分账规则状态" prop="isEnable">
          <Select v-model="divideInfo.isEnable" style="width:200px">
            <Option :key="1" :value="1">开启</Option>
            <Option :key="0" :value="0">已关闭</Option>
          </Select>
        </FormItem>
        <FormItem label="适用学校">
          <div>{{ selectSchoolStr }}</div>
          <Button type="primary" @click="openSelectSchool">请选择</Button>
        </FormItem>
      </Form>
      <div v-if="divideInfo.ruleType&&divideInfo.ruleType.length>0" class="divide-box">
        <div class="divide-left">
          <div class="divide-title">课程类型</div>
          <div class="divide-left-list">
            <div v-for="(item,index) in divideInfo.ruleType" :key="index" :class="item===ruleTypeActive?'left-item-active':''" class="left-item" @click="handleChangeActive(item)">{{ ruleTypeObj[item] }}</div>
          </div>
        </div>
        <div class="divide-right">
          <div class="divide-title">分账规则设置</div>
          <div class="right-content">
            <div class="divide-form">
              <span>分账业务类型：</span>
              <RadioGroup :value="divideTypeShow" @on-change="getDivideType">
                <Radio :label="1">按节次费用比例分账</Radio>
                <Radio v-if="ruleTypeActive===1" :label="2">按节次费用固定分账</Radio>
              </RadioGroup>
            </div>
            <Table style="width:100%;margin:20px 0" border :columns="divideTableColumnShow" :data="dividePartyListShow">
              <template slot="orgName" slot-scope="{ row,index }">
                <div>
                  <span>{{ row.orgName }}</span>
                  <Icon v-if="index>1" type="md-create" @click="handleChangeTriOrg(row,index)"></Icon>
                </div>
              </template>
              <template slot="divideWay" slot-scope="{ row,index }">
                <span v-if="divideTypeShow===1">比例分账</span>
                <span v-else>固定分账</span>
              </template>
              <template slot="divideVal" slot-scope="{ row,index }">
                <div v-if="row.isEdit">
                  <Input
                    v-if="ruleTypeActive===1"
                    v-model="courseDividePartyList[index].divideValInput"
                    style="width: 50px;margin-right: 10px;"
                    placeholder="请输入机构名称"
                    @on-blur="inputBlur(row,index)"
                  ></Input>
                  <Input
                    v-else
                    v-model="mDividePartyList[index].divideValInput"
                    style="width: 50px;margin-right: 10px;"
                    placeholder="请输入机构名称"
                    @on-blur="inputBlur(row,index)"
                  ></Input>
                  <span v-if="divideTypeShow===1">%</span>
                </div>
                <div v-else>
                  <span>{{ row.divideVal }}</span><span v-if="divideTypeShow===1">%</span>
                </div>
              </template>
              <template slot="action" slot-scope="{ row,index }">
                <div v-if="row.isEdit">
                  <span class="click-btn-430" @click="handleCancelEdit(row,index)">取消</span>
                  <span class="click-btn-430" @click="handleSaveEdit(row,index)">保存</span>
                </div>
                <div v-else>
                  <span class="click-btn-430" @click="handleEdit(row,index)">编辑</span>
                  <span v-if="index>1" class="click-btn-430" style="color: red" @click="handleDel(index)">删除</span>
                </div>

              </template>
            </Table>
            <Button @click="handleAddDivideRule">+新增分账对象</Button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button :loading="divideModalLoading" @click="handleCancelDivideRule">取消</Button>
        <Button :loading="divideModalLoading" type="primary" @click="handleSubmitDivideRule">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalShow"
      :width="800"
      title="选择分账对象"
      :footer-hide="true"
      :closable="false"
    >
      <div class="search-line">
        <Input
          v-model="orgName"
          class="search-input"
          placeholder="请输入三方课程机构名称"
        ></Input>
        <Button type="primary" @click="handleSearchTriOrg">搜索</Button>
      </div>
      <RadioOrCheckboxTable
        :single-select-data.sync="selectOrgDataModal"
        :table-column="triOrgTableColumn"
        :table-data="triOrgData"
        :table-total="orgPageInfo.total"
        :table-current="orgPageInfo.pageNum"
        unique-key="orgId"
      ></RadioOrCheckboxTable>
      <div class="modal-footer">
        <Button @click="handleCancleBtn">取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
    <!-- 选择学校 -->
    <ChooseSchoolModal ref="chooseSchoolModal" @on-finish="onSchFinish">
      <template #remark>
        <RemarkCard>
          <p>
            请根据<span style="color: red">监管银行</span>选择对应的学校，不可选错！点击搜索立即查询。
          </p></RemarkCard>
      </template>
    </ChooseSchoolModal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import TablePoptip from '@c/Base/TablePoptip.vue';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable.vue';
import ChooseSchoolModal from '@pv/orderCenter/profitSharing/assets/components/ChooseSchoolModal.vue';
import RemarkCard from '@c/Base/RemarkCard.vue';
import common from '@/request/common';
export default {
  name: 'HangingInfoSet',
  components: {
    TablePoptip,
    RadioOrCheckboxTable,
    ChooseSchoolModal,
    RemarkCard
  },
  data() {
    return {
      tableColumns: [
        {
          title: '分账规则ID',
          key: 'ruleId',
          minWidth: 200
        },
        {
          title: '分账规则名称',
          key: 'ruleName',
          minWidth: 200
        },
        {
          title: '分账业务类型',
          slot: 'ruleType',
          minWidth: 200
        },
        {
          title: '适用学校',
          slot: 'schoolRelDTOList',
          minWidth: 230
        },
        {
          title: '分账规则状态',
          slot: 'isEnable', // 分账规则启用状态 0-未启用 1-启用
          minWidth: 200
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '更新时间',
          key: 'operateTime',
          minWidth: 200
        },
        {
          title: '更新人',
          key: 'operatorName',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          minWidth: 200,
          fixed: 'right'
        }
      ],
      tableData: [],
      tableLoading: false,
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      pageSizeOpts: [10, 20, 50, 100],
      hangingId: this.$route.query.hangingId,
      hangingOrgName: this.$route.query.hangingOrgName,
      hangingOrgId: this.$route.query.hangingOrgId,
      providerId: this.$route.query.goodsProviderId,
      goodsProviderName: this.$route.query.goodsProviderName,
      contractNo: this.$route.query.contractNo,
      hangingEnable: this.$route.query.isValid,
      showDivideModal: false,
      divideModalLoading: false,
      divideInfo: {
        ruleName: '', // 分账规则名称
        isEnable: 1, // 启用状态 0-否 1-是
        ruleType: []// 规则类型 1-素质课 2-托管课 4-材料
      },
      ruleTypeObj: {
        1: '素质课程',
        2: '托管课程',
        4: '材料费',
        5: '素质课程、材料费',
        6: '托管课程、材料费'
      },
      divideInfoRule: {
        ruleName: [
          { required: true, message: '请输入分账规则名称', trigger: 'blur' }
        ],
        ruleType: [
          { required: true, type: 'array', message: '请勾选分账业务类型', trigger: 'change' }
        ],
        isEnable: [
          { required: true, type: 'number', message: '请选择分账规则状态', trigger: 'change' }
        ]
      },
      ruleTypeActive: 1, // 分账规则列表显示哪个
      courseDivideType: 1, //  素质课程分账类型 1-按比例 2-固定金额
      courseDividePartyList: [], // 素质课程分账规则
      mDivideType: 1, // 材料费分账类型 1-按比例 2-固定金额
      mDividePartyList: [], // 材料费分账规则
      modalShow: false,
      orgName: '',
      selectOrgIndex: -1,
      selectOrgDataModal: {},
      triOrgTableColumn: [{ title: '三方课程机构名称',
        key: 'orgName',
        minWidth: 200 }],
      triOrgData: [],
      orgPageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      selectSchoolList: []// 选择的适用学校
    };
  },
  computed: {
    ...mapState(['userInfo']),
    divideTypeShow() {
      if (this.ruleTypeActive === 1) {
        return this.courseDivideType;
      } else {
        return this.mDivideType;
      }
    },
    dividePartyListShow() {
      if (this.ruleTypeActive === 1) {
        return this.courseDividePartyList;
      } else {
        return this.mDividePartyList;
      }
    },
    divideTableColumnShow() {
      if (this.divideTypeShow === 1) {
        return [
          {
            title: '分账对象',
            slot: 'orgName',
            minWidth: 200
          },
          {
            title: '分账方式',
            slot: 'divideWay',
            minWidth: 200
          },
          {
            title: '分账基数',
            slot: 'divideVal',
            minWidth: 200
          },
          {
            title: '操作',
            slot: 'action',
            minWidth: 200
          }
        ];
      } else {
        return [
          {
            title: '分账对象',
            slot: 'orgName',
            minWidth: 200
          },
          {
            title: '分账方式',
            slot: 'divideWay',
            minWidth: 200
          },
          {
            title: '分账基数（元）',
            slot: 'divideVal',
            minWidth: 200
          },
          {
            title: '操作',
            slot: 'action',
            minWidth: 200
          }
        ];
      }
    },
    selectSchoolStr() {
      return this.selectSchoolList.map(item => item.name).join('、');
    },
    selectTriOrgIds() {
      return this.dividePartyListShow.map(item => item.orgId);
    },
    modalTitle() {
      return this.divideInfo.ruleId ? '编辑分账规则' : '新建分账规则';
    }
  },
  watch: {
    'divideInfo.ruleType': {
      deep: true,
      handler(newVal, oldVal) {
        console.log(newVal, '拿到的是----');
        if (newVal.length === 1 && newVal[0] === 4) {
          this.ruleTypeActive = 4;
        } else if (newVal.length === 1 && newVal[0] === 1) {
          this.ruleTypeActive = 1;
        }
      }
    }
  },
  created() {
    this.getHangingDivideRulesList();
  },
  methods: {
    handlePageChange(pageNo) {
      this.pageInfo.pageNo = pageNo;
      this.getHangingDivideRulesList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNo === 1 && this.getHangingDivideRulesList();
    },
    // 获取挂靠分账规则列表
    async getHangingDivideRulesList() {
      this.tableLoading = true;
      try {
        const res = await common.getHangingDivideRulesListApi({
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          hangingId: this.hangingId,
          hangingOrgId: this.$route.hangingOrgId,
          providerId: this.providerId,
          contractNo: this.contractNo,
          hangingEnable: this.hangingEnable
        });
        if (res.status === 200) {
          this.tableData = res.message.list.map(item => {
            return {
              ...item,
              schoolStr: item.schoolRelDTOList ? item.schoolRelDTOList.map(x => x.schoolName).join('、') : ''
            };
          });
          this.pageInfo.total = +res.message.total;
        }
      } finally {
        this.tableLoading = false;
      }
    },
    async handleEditDivideInfo(row) {
      this.$refs.divideInfoForm.resetFields();
      const divideInfo = row.divideInfo ? JSON.parse(row.divideInfo) : [];
      const ruleType = [];
      const orgIdTrue = await this.findHangingOrgIdTrue();
      this.courseDividePartyList = [
        {
          orgId: orgIdTrue, // 分账方id
          orgName: this.hangingOrgName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        },
        {
          orgId: this.providerId, // 分账方id
          orgName: this.goodsProviderName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        }
      ]; // 素质课程分账规则
      this.mDividePartyList = [
        {
          orgId: orgIdTrue, // 分账方id
          orgName: this.hangingOrgName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        },
        {
          orgId: this.providerId, // 分账方id
          orgName: this.goodsProviderName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        }
      ];// 材料费分账规则
      divideInfo.forEach((item, index) => {
        if (index === 0) {
          this.ruleTypeActive = +item.ruleType;
        }
        ruleType.push(+item.ruleType);
        if (+item.ruleType === 1) {
          this.courseDivideType = +item.divideType;
          this.courseDividePartyList = item.dividePartyList.map(x => {
            return {
              orgId: x.orgId, // 分账方id
              orgName: x.orgName,
              divideValInput: x.divideVal / 100 + '',
              divideVal: x.divideVal / 100, // 比例（万分比）/固定金额
              isEdit: false
            };
          });
        }
        if (+item.ruleType === 4) {
          this.mDivideType = +item.divideType;
          this.mDividePartyList = item.dividePartyList.map(x => {
            return {
              orgId: x.orgId, // 分账方id
              orgName: x.orgName,
              divideValInput: x.divideVal / 100 + '',
              divideVal: x.divideVal / 100, // 比例（万分比）/固定金额
              isEdit: false
            };
          });
        }
      });
      this.divideInfo = {
        ruleId: row.ruleId,
        ruleName: row.ruleName, // 分账规则名称
        isEnable: row.isEnable, // 启用状态 0-否 1-是
        ruleType// 规则类型 1-素质课 2-托管课 4-材料
      };
      this.selectSchoolList = row.schoolRelDTOList ? row.schoolRelDTOList.map(item => {
        return {
          name: item.schoolName,
          orgId: item.schoolId,
          id: item.schoolId
        };
      }) : [];
      this.showDivideModal = true;
    },
    async handleDelDivideInfo(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确定删除此条分账规则吗？</p>',
        loading: true,
        onOk: async() => {
          try {
            const res = await common.delRuleApi({
              ruleId: row.ruleId
            });
            if (res.status === 200) {
              this.$Message.success('删除成功');
              this.pageInfo.pageNo = 1;
              this.getHangingDivideRulesList();
            }
          } finally {
            this.$Modal.remove();
          }
        }
      });
    },
    async handleAddDivideInfo() {
      this.$refs.divideInfoForm.resetFields();
      this.ruleTypeActive = 1;
      this.courseDivideType = 1;//  素质课程分账类型 1-按比例 2-固定金额
      const orgIdTrue = await this.findHangingOrgIdTrue();
      if (!orgIdTrue) {
        this.$Message.error('请先在三方课程机构列表添加该课程挂靠机构！');
        return;
      }
      this.courseDividePartyList = [
        {
          orgId: orgIdTrue, // 分账方id
          orgName: this.hangingOrgName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        },
        {
          orgId: this.providerId, // 分账方id
          orgName: this.goodsProviderName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        }
      ]; // 素质课程分账规则
      this.mDivideType = 1; // 材料费分账类型 1-按比例 2-固定金额
      this.mDividePartyList = [
        {
          orgId: orgIdTrue, // 分账方id
          orgName: this.hangingOrgName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        },
        {
          orgId: this.providerId, // 分账方id
          orgName: this.goodsProviderName,
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        }
      ];// 材料费分账规则
      this.selectSchoolList = [];
      this.divideInfo = {
        ruleName: '', // 分账规则名称
        isEnable: 1, // 启用状态 0-否 1-是
        ruleType: []// 规则类型 1-素质课 2-托管课 4-材料
      };
      this.showDivideModal = true;
    },
    getDivideType(value) {
      if (this.ruleTypeActive === 1) {
        this.courseDivideType = value;
      } else {
        this.mDivideType = value;
      }
    },
    handleChangeActive(active) {
      this.ruleTypeActive = active;
    },

    handleAddDivideRule() {
      if (this.ruleTypeActive === 1) {
        this.courseDividePartyList.push({
          orgId: '', // 分账方id
          orgName: '',
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        });
      } else {
        this.mDividePartyList.push({
          orgId: '', // 分账方id
          orgName: '',
          divideValInput: 0,
          divideVal: 0, // 比例（万分比）/固定金额
          isEdit: true
        });
      }
    },
    handleChangeTriOrg(info, index) {
      if (info.orgId) {
        this.selectOrgDataModal = {
          orgId: info.orgId,
          orgName: info.orgName
        };
      } else {
        this.selectOrgDataModal = {};
      }

      this.selectOrgIndex = index;
      this.orgName = '';
      this.handleSearchTriOrg();
      this.modalShow = true;
    },
    async findHangingOrgIdTrue() {
      return new Promise(async(resolve, reject) => {
        try {
          const res = await common.getKhOrgListApi({
            pageNo: 1,
            pageSize: 10,
            orgName: this.hangingOrgName
          });
          if (res.status === 200) {
            const info = res.message.list && res.message.list.length > 0 ? res.message.list[0] : {};
            info.orgName === this.hangingOrgName ? resolve(info.orgId) : resolve('');
          }
        } catch (err) {
          reject(false);
        }
      });
    },
    // 获取机构列表
    async getOrgList() {
      const params = {
        pageNo: this.orgPageInfo.pageNum,
        pageSize: this.orgPageInfo.pageSize
      };
      if (this.orgName) {
        params.orgName = this.orgName;
      }
      const res = await common.getKhOrgListApi(params);
      if (res.status === 200) {
        this.triOrgData = res.message.list.map(item => {
          return {
            ...item,
            _disabled: this.selectTriOrgIds.includes(item.orgId)
          };
        });
        this.orgPageInfo.total = +res.message.total;
      }
    },
    handleSearchTriOrg() {
      this.orgPageInfo.pageNum = 1;
      this.getOrgList();
    },
    handleCancleBtn() {
      this.modalShow = false;
    },
    handleSureBtn() {
      const { orgId, orgName } = this.selectOrgDataModal;
      if (!orgId) {
        this.$Message.error('请选择分账对象');
        return;
      }
      if (this.ruleTypeActive === 1) {
        const info = this.courseDividePartyList[this.selectOrgIndex];
        this.courseDividePartyList.splice(this.selectOrgIndex, 1, { ...info, orgId, orgName });
      } else {
        const info = this.mDividePartyList[this.selectOrgIndex];
        this.mDividePartyList.splice(this.selectOrgIndex, 1, { ...info, orgId, orgName });
      }
      this.modalShow = false;
    },
    handleCancelDivideRule() {
      this.showDivideModal = false;
    },
    handleSubmitDivideRule() {
      this.divideModalLoading = true;
      this.$refs.divideInfoForm.validate((valid) => {
        if (valid) {
          console.log('校验成功');
          const ruleTag = this.checkDivideRuleTrue();
          ruleTag ? this.judgeEditOrAdd() : this.divideModalLoading = false;
        } else {
          this.divideModalLoading = false;
        }
      });
    },
    judgeEditOrAdd() {
      const hangingDivideRuleInfoList = this.divideInfo.ruleType.map(item => {
        const dividePartyListOrigin = item === 1 ? this.courseDividePartyList : this.mDividePartyList;
        const obj = {
          divideType: item === 1 ? this.courseDivideType : this.mDivideType,
          ruleType: item,
          dividePartyList: dividePartyListOrigin.map(x => { return { orgId: x.orgId, divideVal: x.divideVal * 100 }; })
        };
        return obj;
      });
      const schoolIds = this.selectSchoolList.map(item => item.id);
      if (this.divideInfo.ruleId) {
        this.submitEditTrue(hangingDivideRuleInfoList, schoolIds);
      } else {
        this.submitAddTrue(hangingDivideRuleInfoList, schoolIds);
      }
    },
    async submitEditTrue(hangingDivideRuleInfoList, schoolIds) {
      const params = {
        ruleId: this.divideInfo.ruleId,
        ruleName: this.divideInfo.ruleName,
        isEnable: this.divideInfo.isEnable,
        schoolIds: schoolIds.length > 0 ? schoolIds : null,
        hangingDivideRuleInfoList
      };
      try {
        const res = await common.updateRuleApi(params);
        if (res.status === 200) {
          this.$Message.success('编辑成功');
          this.showDivideModal = false;
          this.getHangingDivideRulesList();
        }
      } finally {
        this.divideModalLoading = false;
      }
    },
    async submitAddTrue(hangingDivideRuleInfoList, schoolIds) {
      const params = {
        hangingId: this.hangingId,
        ruleName: this.divideInfo.ruleName,
        isEnable: this.divideInfo.isEnable,
        schoolIds: schoolIds.length > 0 ? schoolIds : null,
        hangingDivideRuleInfoList
      };
      try {
        const res = await common.addRuleApi(params);
        if (res.status === 200) {
          this.$Message.success('添加成功');
          this.showDivideModal = false;
          this.pageInfo.pageNo = 1;
          this.getHangingDivideRulesList();
        }
      } finally {
        this.divideModalLoading = false;
      }
    },
    checkDivideRuleTrue() {
      if (this.divideInfo.ruleType.length === 1) {
        return this.checkListError(this.dividePartyListShow, this.ruleTypeActive, this.divideTypeShow);
      }
      let tag = false;
      for (let i = 0; i < this.divideInfo.ruleType.length; i++) {
        const ruleType = this.divideInfo.ruleType[i];
        tag = this.checkListError(ruleType === 1 ? this.courseDividePartyList : this.mDividePartyList, ruleType, ruleType === 1 ? this.courseDivideType : this.mDivideType);
        if (!tag) {
          break;
        }
      }
      console.log(tag, '拿到的=====');
      return tag;
    },
    checkListError(dividePartyList, ruleType, divideType) {
      const allIsFinish = this.checkAllIsNoEdit(dividePartyList);
      if (!allIsFinish) {
        this.$Message.error(`请先保存所有${this.ruleTypeObj[ruleType]}的数据`);
        return allIsFinish;
      }
      const allHasOrgId = this.checkHasOrgId(dividePartyList);
      if (!allHasOrgId) {
        this.$Message.error(`${this.ruleTypeObj[ruleType]}的分账对象没有全部选择`);
        return allHasOrgId;
      }
      if (ruleType === 1 && divideType === 2) {
        return true;
      }
      const isHundred = this.checkDivideNumIsHundred(dividePartyList);
      if (!isHundred) {
        this.$Message.error(`${this.ruleTypeObj[ruleType]}的分账基数累加之和不为100%`);
        return isHundred;
      }
      return true;
    },
    checkHasOrgId(list) {
      return list.every(item => item.orgId);
    },
    checkAllIsNoEdit(list) {
      return list.every(item => !item.isEdit);
    },
    checkDivideNumIsHundred(list) {
      const total = list.reduce((pre, cur) => {
        return pre + +cur.divideVal;
      }, 0);
      return total === 100;
    },
    handleCancelEdit(row, index) {
      if (this.ruleTypeActive === 1) {
        this.courseDividePartyList.splice(index, 1, { ...row, isEdit: false });
      } else {
        this.mDividePartyList.splice(index, 1, { ...row, isEdit: false });
      }
    },
    handleSaveEdit(row, index) {
      if (this.ruleTypeActive === 1) {
        this.courseDividePartyList.splice(index, 1, { ...row, divideVal: row.divideValInput, isEdit: false });
      } else {
        this.mDividePartyList.splice(index, 1, { ...row, divideVal: row.divideValInput, isEdit: false });
      }
    },
    handleEdit(row, index) {
      if (this.ruleTypeActive === 1) {
        this.courseDividePartyList.splice(index, 1, { ...row, isEdit: true });
      } else {
        this.mDividePartyList.splice(index, 1, { ...row, isEdit: true });
      }
    },
    handleDel(index) {
      if (this.ruleTypeActive === 1) {
        this.courseDividePartyList.splice(index, 1);
      } else {
        this.mDividePartyList.splice(index, 1);
      }
    },
    inputBlur(row, index) {
      const inputStr = row.divideValInput;
      if (isNaN(inputStr)) {
        this.$Message.error('请输入数字');
        if (this.ruleTypeActive === 1) {
          this.courseDividePartyList.splice(index, 1, { ...row, divideValInput: '0' });
        } else {
          this.mDividePartyList.splice(index, 1, { ...row, divideValInput: '0' });
        }
        return;
      }
      if (+inputStr < 0) {
        this.$Message.error('请输入大于0的数字');
        if (this.ruleTypeActive === 1) {
          this.courseDividePartyList.splice(index, 1, { ...row, divideValInput: '0' });
        } else {
          this.mDividePartyList.splice(index, 1, { ...row, divideValInput: '0' });
        }
        return;
      }
      let length = 0;
      const arr = inputStr.split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (length > 2) {
        this.$Message.error('请输入最多两位小数');
        if (this.ruleTypeActive === 1) {
          this.courseDividePartyList.splice(index, 1, { ...row, divideValInput: '0' });
        } else {
          this.mDividePartyList.splice(index, 1, { ...row, divideValInput: '0' });
        }
        return;
      }
      if (this.ruleTypeActive === 1) {
        this.courseDividePartyList.splice(index, 1, { ...row, divideValInput: +inputStr });
      } else {
        this.mDividePartyList.splice(index, 1, { ...row, divideValInput: +inputStr });
      }
    },
    openSelectSchool() {
      this.$refs.chooseSchoolModal.handleOpen(this.selectSchoolList);
    },
    onSchFinish(result) {
      this.selectSchoolList = result.map(item => {
        return {
          name: item.name,
          orgId: item.orgId,
          id: item.orgId
        };
      });
      this.$refs.chooseSchoolModal.handleClosure();
    }

  }
};
</script>
<style lang='scss' scoped>
.title-block{
  background: rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 24px;
}
.content-line{
  flex: 1;
  .line-left{
    display: inline-block;
    width: 120px;
    box-sizing: border-box;
    padding-left: 15px;
    position:relative;
    &::before{
      content: '*';
      position: absolute;
      top: 50%;
      left: 5px;
      transform: translateY(-50%);
      color: red;
    }
  }
}
.divide-box{
  display: flex;
  justify-content: space-between;
  .divide-left{
    width: 20%;
    flex-shrink: 0;
    border: 1px solid #ccc;
    .left-item{
      margin-top: 10px;
      height:40px ;
      line-height: 40px;
      text-align: center;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
    }
    .left-item-active{
      color: #488ffa;
      position: relative;
      &::before{
        content: '';
        display: inline-block;
        background: #488ffa;
        position: absolute;
        width: 5px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .divide-right{
    width: 76%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    .right-content{
      padding: 20px;
    }
  }
  .divide-title{
    height: 40px;
    background: #488ffa;
    color: #fff;
    line-height: 40px;
    padding-left: 10px;
  }
  .divide-form{
    display: flex;
    align-items: center;
  }
}

.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 200px;
    margin-right: 16px;
  }
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button + button {
    margin-left: 8px;
  }
}
</style>
